import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'


export const options  ={
    theme: {
        primary: '#03A9F4',
        secondary: '#03A9F4',
        accent: '#03A9F4',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        dark:false
    },
    customProperties: true,
    iconfont: 'mdi'
};
Vue.use(Vuetify);
